// Login.js
import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../../css/login.css";
import { toast } from "react-toastify";

import logo from "../../images/hosming_rojo.jpg";
import Swal from "sweetalert2";
import { ApiService } from "../../components/ApiService";

export const LoginSuperAdmin = () => {
	const API_url = process.env.REACT_APP_API_URL;
	const [telefono, setTelefono] = useState("");
	const [codigo, setCodigo] = useState(Array(7).fill(""));
	const [errors, setErrors] = useState({});
	const navigate = useNavigate();
	const codigoRefs = useRef([]);

	const validateForm = () => {
		const newErrors = {};
		if (!telefono) {
			newErrors.telefono = "*";
		}
		if (codigo.join("").length < 7) {
			toast.error("El código debe tener exactamente 7 dígitos", { position: "top-right" });
			newErrors.codigo = "*";
		}
		if (telefono === "") {
			toast.error("Complete el número de teléfono", { position: "top-right" });
		}
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleTelefonoChange = (e) => {
		const value = e.target.value;
		if (/^[0-9]*$/.test(value)) {
			setTelefono(value);
		}
	};

	const handleCodigoChange = (index, value) => {
		if (/^\d?$/.test(value)) {
			const newCodigo = [...codigo];
			newCodigo[index] = value;
			setCodigo(newCodigo);

			if (value && index < 6) {
				codigoRefs.current[index + 1].focus();
			} else if (!value && index > 0) {
				codigoRefs.current[index - 1].focus();
			}
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (validateForm()) {
			const codigoFinal = codigo.join("");
		}
	};

	return (
		<>
			<Helmet>
				<link
					href="https://fonts.googleapis.com/css?family=Lato:300,400,700,900&display=swap"
					rel="stylesheet"
				/>
				<link
					rel="stylesheet"
					href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
				/>
			</Helmet>
			<section className="ftco-section">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-md-12 col-lg-10">
							<div className="wrap d-md-flex">
								<div
									className="text-wrap p-4 p-lg-5 text-center d-flex align-items-center order-md-last"
									style={{ background: "#a10302" }}>
									<div className="text w-100">
										<img src={logo} alt="logo" className="img-logo" />
										<h2>Bienvenido(a)</h2>
										<h3 style={{ color: "#fff", fontWeight: "700" }}>Super Admin</h3>
									</div>
								</div>
								<div className="login-wrap p-4 p-lg-5">
									<h3 className="mb-4" style={{ textAlign: "left", fontWeight: "500" }}>
										Iniciar Sesión
									</h3>
									<form className="signin-form" onSubmit={handleSubmit}>
										<div className="form-group mb-3" style={{ position: "relative" }}>
											<label className="label" htmlFor="telefono">
												Teléfono
											</label>
											{errors.telefono && <span style={{ color: "red" }}>{errors.telefono}</span>}
											<input
												type="tel"
												className="form-control"
												placeholder="Ingrese el número de teléfono"
												value={telefono}
												onChange={handleTelefonoChange}
												minLength={8}
												style={{ paddingRight: "80px" }}
											/>
											<button
												type="button"
												className="btn btn-primary"
												disabled={telefono.length < 8}
												style={{
													position: "absolute",
													right: "10px",
													top: "68%",
													transform: "translateY(-50%)",
													background: telefono.length >= 8 ? "#a10302" : "#ccc",
													border: "1px solid #820000",
													padding: "5px 10px",
													cursor: telefono.length >= 8 ? "pointer" : "default",
												}}>
												Enviar
											</button>
										</div>
										<div className="form-group mb-3">
											<label className="label" htmlFor="codigo">
												Código
											</label>
											{errors.codigo && <span style={{ color: "red" }}>{errors.codigo}</span>}
											<div
												style={{
													display: "flex",
													flexDirection: "row",
													justifyContent: "space-between",
												}}>
												{codigo.map((digit, index) => (
													<input
														key={index}
														type="text"
														maxLength="1"
														className="form-control text-center"
														value={digit}
														ref={(el) => (codigoRefs.current[index] = el)}
														onChange={(e) => handleCodigoChange(index, e.target.value)}
														style={{
															width: "40px",
															height: "40px",
															textAlign: "center",
															padding: "0",
															borderRadius: "0",
														}}
													/>
												))}
											</div>
										</div>
										<div className="form-group">
											<button
												type="submit"
												className="form-control btn btn-primary submit px-3 custom-btn"
												style={{ background: "#a11d1c", marginTop: "30px" }}>
												Ingresar
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
